import { Box, Typography } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'
import PropTypes from 'prop-types'

import { BasePermissionsForm } from '../index'

import constants from 'constants/index'

const ChurnForm = ({ permissions, handleChange }) => {
  const { register } = useFormContext()

  const { churnList, churnReasonList } =
    constants.permissionsLists.collaboratorProfileLists

  return (
    <>
      <Box mt={2} mb={3}>
        <Typography variant="h5">Solicitações de churns</Typography>
      </Box>
      <BasePermissionsForm
        title="Churns"
        permissionsList={churnList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
      />
      <BasePermissionsForm
        title="Motivos"
        permissionsList={churnReasonList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
      />
    </>
  )
}

ChurnForm.propTypes = {
  register: PropTypes.func,
  permissions: PropTypes.object,
  handleChange: PropTypes.func,
}

export default ChurnForm
